import axios from 'axios'
import { Message } from 'element-ui'

// 創建 axios 實例
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/api' : 'https://demo-table.buzigai.com/api', // API 基礎路徑
  timeout: 120000, // 2分钟超时
  headers: {
    'Content-Type': 'application/json'
  }
})

// 請求攔截器
service.interceptors.request.use(
  config => {
    // 简单的文件上传处理
    if (config.headers['Content-Type'] === 'multipart/form-data') {
      // 让浏览器自动设置Content-Type和boundary
      delete config.headers['Content-Type']
    }

    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 響應攔截器
service.interceptors.response.use(
  response => {
    // 如果响应类型是blob，直接返回blob数据
    if (response.config.responseType === 'blob') {
      return response.data
    }

    const res = response.data

    // 根據後端約定的狀態碼進行處理
    if (res.code === 200) {
      return res
    } else {
      Message.error(res.msg || '請求失敗')
      return Promise.reject(new Error(res.msg || '請求失敗'))
    }
  },
  error => {
    console.error('Response error:', error)
    Message.error(error.message || '請求失敗')
    return Promise.reject(error)
  }
)

export default service